/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_E2_Extra_Point_2_TextInputs */

const en_visa_e2_extra_point_2_text = /** @type {(inputs: Visa_E2_Extra_Point_2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Many E cases turn on whether the financial, corporate, and operational documents clearly support the claimed activity.`)
};

const pt_visa_e2_extra_point_2_text = /** @type {(inputs: Visa_E2_Extra_Point_2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muitos casos E dependem de se os documentos financeiros, corporativos e operacionais apoiam claramente a atividade alegada.`)
};

const es_visa_e2_extra_point_2_text = /** @type {(inputs: Visa_E2_Extra_Point_2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muchos casos E dependen de si los documentos financieros, corporativos y operativos respaldan claramente la actividad alegada.`)
};

/**
* | output |
* | --- |
* | "Many E cases turn on whether the financial, corporate, and operational documents clearly support the claimed activity." |
*
* @param {Visa_E2_Extra_Point_2_TextInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_e2_extra_point_2_text = /** @type {((inputs?: Visa_E2_Extra_Point_2_TextInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_E2_Extra_Point_2_TextInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_e2_extra_point_2_text(inputs)
	if (locale === "es") return es_visa_e2_extra_point_2_text(inputs)
	return en_visa_e2_extra_point_2_text(inputs)
});